export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "يرجى إدخال نصك هنا",
      conversationalPlaceholder: "يرجى إدخال إجابتك هنا",
      conversationClosed: "تم إغلاق المحادثة.",
      conversationalDisclaimer: "سيتم إنشاء أسئلة المتابعة بواسطة الذكاء الاصطناعي بناءً على إجاباتك."
    },
    openText: {
      openEndPlaceholder: "يرجى إدخال نصك هنا"
    },
    multiText: {
      fieldPlaceholder: 'إجابة {number}',
      instruction: 'اكتب إجابة واحدة على الأقل أدناه، إجابة واحدة في كل مربع نص | اكتب {count} إجابات على الأقل أدناه، إجابة واحدة في كل مربع نص',
      instructionWithoutMinimum: 'اكتب إجاباتك أدناه، إجابة واحدة في كل مربع نص',
      minimumEntries: 'يرجى إدخال إجابة واحدة على الأقل للمتابعة. | يرجى إدخال {count} إجابات على الأقل للمتابعة.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'علامة تجارية {number}',
        minimumEntries: 'يرجى إدخال علامة تجارية واحدة على الأقل للمتابعة. | يرجى إدخال {count} علامات تجارية على الأقل للمتابعة.'
      }
    },
    multiselect: {
      caption: "اختر جميع الخيارات التي تنطبق"
    },
    rankOrder: {
      enterRankOrder: "أدخل الترتيب",
      placeholder: "اسحب اختياراتك هنا لترتيبها"
    },
    openNumeric: {
      label: "إدخال رقمي مفتوح"
    },
    complete: {
      message: "شكرًا لك على إكمال هذا الاستبيان."
    },
    openVideo: {
      warning: "يرجى تسجيل فيديو قبل المتابعة.",
      uploadStatusUploading: "يرجى الانتظار حتى ننهي معالجة الفيديو الخاص بك للمتابعة...",
      uploadStatusSuccess: "اكتمل التحميل بنجاح، يمكنك المتابعة.",
      uploadStatusError: "لم يكتمل التحميل، يرجى المحاولة مرة أخرى."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'يُرجى إدخال بريد إلكتروني صالح',
      text_invalid_phone: 'يُرجى إدخال رقم هاتف صالح',
      text_invalid_us_zip: 'يُرجى إدخال رمز بريدي أمريكي (ZIP) صالح',
      text_invalid_ca_postal: 'يُرجى إدخال رمز بريدي كندي صالح',
      text_invalid_uk_postal: 'يُرجى إدخال رمز بريدي بريطاني صالح',
      text_invalid_custom: 'يُرجى إدخال {fieldName} صالح',
      text_min_chars: 'يُرجى إدخال {min} أحرف على الأقل',
      text_max_chars: 'يُرجى عدم إدخال أكثر من {max} حرفًا',
      text_alpha_not_allowed: 'يُسمح بالأرقام فقط',
      text_numeric_not_allowed: 'يُسمح بالأحرف الأبجدية فقط'
    },
    external: {
      invalid: 'إجابة هذا السؤال غير صالحة.',
      required: 'لا بد من الإجابة على هذا السؤال.',
      singlechoice_required: 'يرجى تحديد خيار قبل المتابعة.',
      numeric_required: 'يرجى تحديد تقييم قبل المتابعة.',
      text_required: 'يرجى إدخال إجابة قبل المتابعة.',
      bigtext_required: 'يرجى إدخال إجابة قبل المتابعة.',
      singlechoiceother_incomplete: 'يرجى إدخال إجابة قبل المتابعة.',
      multiselectother_incomplete: 'يرجى إدخال إجابة قبل المتابعة.',
      numeric_invalid: 'يرجى إدخال رقم صالح قبل المتابعة.',
      radiogrid_required: 'يرجى تحديد خيار لكل صف قبل المتابعة.',
      incomplete: 'يُرجى استكمال هذا السؤال بالكامل قبل المتابعة.',
      multiselect_min: 'يرجى تحديد {value} خيار على الأقل قبل المتابعة.',
      multiselect_max: 'يرجى تحديد {value} خيار كحد أقصى قبل المتابعة.',
      multiselectother_min: 'يرجى تحديد {value} خيار على الأقل قبل المتابعة.',
      multiselectother_max: 'يرجى تحديد {value} خيار كحد أقصى قبل المتابعة.',
      multiselectgrid_min: 'يرجى تحديد {value} خيار على الأقل لكل صف قبل المتابعة.',
      multiselectgrid_max: 'يرجى تحديد {value} خيار كحد أقصى لكل صف قبل المتابعة.',
      rankorder_min: 'يرجى تصنيف {value} عنصر على الأقل قبل المتابعة.',
      rankorder_max: 'يرجى تصنيف {value} عنصر كحد أقصى قبل المتابعة.'
    }
  }
}
